import React, { useEffect } from 'react';
import styles from '@/styles/Headline.module.scss';
import { PEIHeadLine } from '@/common/components/PEIHeadline';
import { HeadLineItems } from './headlineItem';
import { HeadlinesPlaceholder } from './index';
import { URL } from '@/utils';
import { PEISectionFooter, defaultImagePath } from '@/common';
import { getCTAS } from '@/utils';
import { useAppContext } from '@/components';
import { ZephrFeature } from '@/components/ZephrFeature';

const { basePEIURL } = URL;

type mentionItemsProp = {
  image: string;
  title: string;
  summary: string;
  type: string;
  postName: string;
  thumbnail: string;
};

type mentionedStoriesProp = {
  institutionID: string;
  institutionName: string;
  userType: string;
  partnerStatus: string;
  mentionItems: mentionItemsProp[];
};

export const MentionedStories = ({
  mentionItems,
  institutionName,
  userType,
  institutionID,
  partnerStatus,
}: mentionedStoriesProp) => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    dispatch({
      type: 'setRecordInfo',
      payload: {
        key: 'mentions',
        value: mentionItems.length > 0,
      },
    });
  }, [dispatch, mentionItems]);

  const allData = getCTAS(userType, institutionName, institutionID);
  const headlinesComponentData: {
    LP: string;
    GP: string;
    'LP/GP': string;
  } = allData['HeadlinesComponent'];

  const ctas = {
    ctaButton: '',
  };

  switch (partnerStatus) {
    case 'LP':
      ctas.ctaButton = headlinesComponentData.LP;
      break;
    case 'GP':
      ctas.ctaButton = headlinesComponentData.GP;
      break;
    case 'LP/GP':
      ctas.ctaButton = headlinesComponentData['LP/GP'];
      break;
  }

  return (
    <>
      {mentionItems.length > 0 && (
        <article className={styles.container} id='mentions'>
          <main className={styles['container-body']}>
            <PEIHeadLine text={`Stories that mention ${institutionName}`} />
            <ZephrFeature
              placeholder={
                <HeadlinesPlaceholder institutionName={institutionName} showImages={false} />
              }
            >
              <div className={styles.galleyContainer}>
                {mentionItems.map((item, id) => (
                  <HeadLineItems
                    key={id + 'mention'}
                    imageURL={item?.thumbnail ? item?.thumbnail : defaultImagePath}
                    headingText={item.title}
                    contentText={item.summary}
                    link={`${basePEIURL}/${item?.postName}`}
                    showImages={false}
                  />
                ))}
              </div>
            </ZephrFeature>
          </main>
          <PEISectionFooter
            textToShow={`See all news that mentions <span class="OverViewComponent_keep-together__q8Hq_">${institutionName} &gt;</span>`}
            link={ctas.ctaButton}
          />
        </article>
      )}
    </>
  );
};
